// extracted by mini-css-extract-plugin
export var compactFilters = "_fd-4";
export var detailImage = "_fd-1";
export var dropdownContainer = "_fd-2";
export var imageContainer = "_fd-0";
export var selectedCard = "_fd-3";